<template>
  <div class="login-container">
    <div class="login-weaper animated bounceInDown">
      <div class="login-left">
        <!-- <img class="img" src="/img/p_logo1.png" alt="" /> -->
        <p class="img f-s-30 f-w-600">语联网管理平台</p>
        <p class="edn">©{{ currentYear }} v1.0.0</p>
      </div>
      <div class="login-border">
        <div class="login-main">
          <userLogin v-if="activeName === 'user'"></userLogin>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/styles/login.scss';
import userLogin from './userlogin';
import { mapGetters } from 'vuex';
import { getStore, setStore } from '@/util/store';
import { dateFormat } from '@/util/date';
import { validatenull } from '@/util/validate';

export default {
  name: 'login',
  components: {
    userLogin,
  },
  data() {
    return {
      activeName: 'user',
      currentYear: new Date().getFullYear(),
    };
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(['website']),
  },
  props: [],
  methods: {},
};
</script>
